module.exports = __webpack_public_path__ + "static/img/COC2021-33.07bb7b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/meeting/COC2021-33.jpg
// module id = pzkU
// module chunks = 0